import React from 'react';
import cx from './cx';

const WIDTHS = {
  narrow: 'max-w-3xl',
  default: 'max-w-6xl',
  wide: 'max-w-7xl',
  full: 'max-w-none',
};

/** Page wrapper: consistent gutters (16px on phones) and max width. */
export function PageContainer({ width = 'default', className, children, ...rest }) {
  return (
    <div className={cx('mx-auto w-full px-4 py-4 sm:px-6 lg:px-8 lg:py-6', WIDTHS[width] || WIDTHS.default, className)} {...rest}>
      {children}
    </div>
  );
}

/** The single h1 of a page, with optional description, eyebrow and actions. */
export function PageHeader({ title, description, eyebrow, actions, compact = false, className, children }) {
  return (
    <header className={cx(compact ? 'mb-3' : 'mb-4', 'flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between', className)}>
      <div className="min-w-0">
        {eyebrow && <p className="mb-1 text-xs font-medium uppercase tracking-wide text-fg-muted">{eyebrow}</p>}
        <h1 className="text-xl font-semibold tracking-tight text-fg sm:text-2xl">{title}</h1>
        {description && <p className="mt-0.5 max-w-2xl text-sm text-fg-muted">{description}</p>}
        {children}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </header>
  );
}

/** h2-level section heading with optional actions on the right. */
export function SectionHeader({ title, description, actions, as: Heading = 'h2', id, className }) {
  return (
    <div className={cx('mb-3 flex flex-wrap items-end justify-between gap-2', className)}>
      <div className="min-w-0">
        <Heading id={id} className="text-base font-semibold text-fg">{title}</Heading>
        {description && <p className="mt-0.5 text-sm text-fg-muted">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
